import React from "react";
import { TeaWordmark } from "@/components/TeaWordmark";
import { useSearchParams } from "react-router-dom";
import { TeaLogo } from "@/components/TeaLogo";
import { publicDocApi } from "@/lib/docApi";
import { RecipientDocView } from "@/components/nds/windows/doc/parts";

export default function DocSignPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  return (
    <main data-testid="doc-sign-page" className="min-h-screen bg-[#07080a] text-white px-4 py-10 sm:py-14">
      <div className="max-w-3xl mx-auto space-y-6">
        <header className="space-y-1">
          <TeaLogo size={60} testid="doc-public-logo" className="mb-3" />
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#d4a017]"><TeaWordmark small text="The Exchange Alliance" testid="doc-public-wordmark" /> · Secure Document</div>
          <p className="text-xs text-white/50">One-time link. No account needed. It stops working once you sign or after 72 hours.</p>
        </header>
        {token
          ? <RecipientDocView api={publicDocApi} path={`/public/${encodeURIComponent(token)}`} prefix="doc-public" />
          : <p data-testid="doc-public-missing" className="text-red-300">This link is missing its token.</p>}
      </div>
    </main>
  );
}
